import request from '@/utils/ai-train-request'

// 四组受众权限：4 客户等级 / 5 技术等级 / 6 全体内部员工 / 7 注册角色。
const apiPath = '/admin/scene-auth'

const aiTrainAuthApi = {
  /**
   * 查询某个场景或某个分类当前的授权列表
   * @param {object} query {sceneId} 或 {categoryId}，二选一
   */
  fetchAudiences() {
    return request({ url: `${apiPath}/audiences`, method: 'get' })
  },
  fetchList(query) {
    return request({ url: apiPath, method: 'get', params: query })
  },
  /**
   * 替换所选对象的四组受众配置；历史其他方式的数据不作为新权限解释。
   */
  save(data) {
    return request({ url: apiPath, method: 'put', data })
  }
}

export default aiTrainAuthApi
